import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { ConstantsService } from '../../../../services/constants/constants.service';
import { WarningModalService } from '../../../../services/warning-modal/warning-modal.service';
import { AbstractModalComponent } from '../../../abstract-modal/abstract-modal.component';

@Component({
  selector: 'app-add-recipient-background-check-modal',
  templateUrl: './add-recipient-background-check-modal.component.pug',
  styleUrls: ['./add-recipient-background-check-modal.component.scss'],
  standalone: false
})
export class AddRecipientBackgroundCheckModalComponent extends AbstractModalComponent implements OnInit {
  public nextClick: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild('requestForm', {static: false}) requestForm: any;
  @Input() backgroundCheck: any;
  @Input() backgroundChecks: any;
  total = 0;
  errorMessage = {
    'type': '',
    'message': ''
  };
  errorTotalRefs = $localize`The number of total recipients for reference surveys cannot exceed 100. `
  internalReferenceTooltip = $localize`This is for internal records only and will not be shown to the candidate or referee.`
  recipient: any = {
    email: '',
    mobile_phone: '',
  };
  disableSend = true;
  saved = false;
  SD_5728_TMP_VALIDATION = false;
  employmentSectorDropDownOptions = ConstantsService.EMPLOYMENT_SECTOR
  employmentTypeDropDownOptions = ConstantsService.EMPLOYMENT_TYPE
  acicBackgroundCheck = ConstantsService.ACIC_SHORT_NAME;
  nccpcBackgroundCheck = ConstantsService.NCC_PC_SHORT_NAME;
  nccbankruptcyBackgroundCheck = ConstantsService.NCC_BANKRUPTCY_SHORT_NAME;
  amlBackgroundCheck = ConstantsService.AML_SHORT_NAME;
  bannedBackgroundCheck = ConstantsService.BANNED_SHORT_NAME;
  ukdbsBackgroundCheck = ConstantsService.UKDBSC_SHORT_NAME;
  cvsqBackgroundCheck = ConstantsService.CV_SQ_SHORT_NAME;
  edusqBackgroundCheck = ConstantsService.EDUV_SQ_SHORT_NAME;

  empsqBackgroundCheck = ConstantsService.EMPV_SQ_SHORT_NAME;
  empcpBackgroundCheck = ConstantsService.EMPV_CP_SHORT_NAME;
  employmentcoverage = _.cloneDeep(ConstantsService.EMPLOYMENT_COVERAGE);
  employmentQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  employmentQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  flowsSelected: any = [];
  checkNames = {
    [this.acicBackgroundCheck] : ['role', 'hiring_organisation'],
    [this.ukdbsBackgroundCheck] : ['role', 'employment_sector'],
    [this.nccpcBackgroundCheck] : ['reason', 'place_work', 'type'],
  };
  selectType = $localize`Select type`;
  emailOutOfFocus: boolean = false;
  mobileNumberTouched: boolean = false;
  yearOptions: { key: string; value: string }[] = [];
  fuzzinessOptions: { key: string; value: string }[] = ConstantsService.FUZZINESSOPTIONS;
  birthYearPlaceholder = ConstantsService.BIRTH_YEAR_PLACEHOLDER
  countryPlaceholder = ConstantsService.AML_COUNTRY_PLACEHOLDER
  fuzzinessToolTip = ConstantsService.FUZZINESS_TOOLTIP
  countryItems: any = []
  selectedItems = []
  fuzziness = 'Exact match';

  bgCheckShortNames: any = []; // Used for easier pug file checks status
  flowShortNames: any = [];
  template;

  // Used for faster look up in conditions
  selectedChecksMap = {
    [ConstantsService.ACIC_SHORT_NAME]: false,
    [ConstantsService.UKDBSC_SHORT_NAME]: false,
    [ConstantsService.NCC_PC_SHORT_NAME]: false,
    [ConstantsService.NCC_BANKRUPTCY_SHORT_NAME]: false,
    [ConstantsService.AML_SHORT_NAME]: false,
    [ConstantsService.BANNED_SHORT_NAME]: false,
    [ConstantsService.CV_SHORT_NAME]: false,
    [ConstantsService.CV_SQ_SHORT_NAME]: false,
    [ConstantsService.CV_HL_SHORT_NAME]: false,
    [ConstantsService.EDUV_SHORT_NAME]: false,
    [ConstantsService.EDUV_SQ_SHORT_NAME]: false,
    [ConstantsService.EDUV_HL_SHORT_NAME]: false,
    [ConstantsService.EMPV_SHORT_NAME]: false,
    [ConstantsService.EMPV_CP_SHORT_NAME]: false,
    [ConstantsService.EMPV_SQ_SHORT_NAME]: false,
    [ConstantsService.SMC_SHORT_NAME]: false,
    [ConstantsService.EIVC_SHORT_NAME]: false,
  }
  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;
  requestTemplate = false;
  TRUST_920_NCC_TYPE = false;


  constructor(public _bsModalRef: BsModalRef,
    public modal: WarningModalService,
    private permissions: PermissionsService
  ) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.ENT_8918_MULTIPLE_BC = this.permissions.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.requestTemplate = this.permissions.isFeatureActivated('ent-10605-request-templates');
    this.TRUST_920_NCC_TYPE = this.permissions.isFeatureActivated('trust-920-ncc-type');
    if(this.requestTemplate && this.template){
        this.recipient.internal_reference =  ''
    }
    if(this.ENT_8918_MULTIPLE_BC){
      this.bgCheckShortNames = this.backgroundChecks.map(check => check.short_name)
      this.bgCheckShortNames?.forEach(checkShortName => {
        if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
          this.selectedChecksMap[checkShortName] = true;
      })
    }
    if(this.TRUST_752_VERIFICATION && this.flowsSelected.length){
        this.flowShortNames = this.flowsSelected.map(check => check.short_name)
        this.flowShortNames?.forEach(checkShortName => {
            if (this.selectedChecksMap && checkShortName in this.selectedChecksMap)
              this.selectedChecksMap[checkShortName] = true;
        })
    }

    this.checkTotalRecipients();
    this.SD_5728_TMP_VALIDATION = this.permissions.isFeatureActivated('SD_5728_TMP_VALIDATION');
    this.checkNames = {
        ...this.checkNames,
        [this.nccbankruptcyBackgroundCheck]: ['reason', 'place_work', 'type'],
    };
    if (this.TRUST_752_VERIFICATION) {
      this.checkNames = {
        ...this.checkNames,
        [this.cvsqBackgroundCheck]: ['verification_cred_min', 'verification_cred_max'],
        [this.edusqBackgroundCheck]: ['verification_qual_min', 'verification_qual_max'],
        [this.empsqBackgroundCheck]: ['verification_emp_min', 'verification_emp_max'],
        [this.empcpBackgroundCheck]: ['verification_years']
      };

      if (this.selectedChecksMap[this.empcpBackgroundCheck]){
          this.recipient['verification_years'] = '5'
      }
      if (this.selectedChecksMap[this.empsqBackgroundCheck]){
          this.recipient['verification_emp_min'] = '2'
          this.recipient['verification_emp_max'] = '3'
      }
      if (this.selectedChecksMap[this.edusqBackgroundCheck]){
          this.recipient['verification_qual_min'] = '1'
          this.recipient['verification_qual_max'] = '3'
      }
      if (this.selectedChecksMap[this.cvsqBackgroundCheck]){
          this.recipient['verification_cred_min'] = '1'
          this.recipient['verification_cred_max'] = '3'
      }
      if (this.TRUST_920_NCC_TYPE && (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck] || this.selectedChecksMap[this.nccpcBackgroundCheck])){
          this.recipient['type'] = this.employmentTypeDropDownOptions[0].key;
          this.selectType = this.employmentTypeDropDownOptions[0].value;
      }
    }
    this.selectedItems = [];

    if(this.ENT_8918_MULTIPLE_BC){
      if(this.selectedChecksMap[this.amlBackgroundCheck]){
      this.recipient['fuzziness'] = 'exact_match'
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 1870; year--) {
        this.yearOptions.push({
          key: year.toString(),
          value: year.toString(),
        });
      }
      }
    }
    else{
      if(this.backgroundCheck === this.amlBackgroundCheck){
        this.recipient['fuzziness'] = 'exact_match'
        const currentYear = new Date().getFullYear();
        for (let year = currentYear; year >= 1870; year--) {
          this.yearOptions.push({
            key: year.toString(),
            value: year.toString(),
          });
        }
      }
    }

  }

  changeValue() {
    // making sure that either email or phone is entered before allowing data
    if (this.recipient.first_name?.trim() && this.recipient.last_name?.trim() && this.recipient.email && this.recipient.mobile_phone && (!this.requestTemplate || (this.requestTemplate && (!(!!this.template) || (!!this.template && this.recipient.internal_reference?.trim()))))) {
      this.checkRequiredFieldsForCheckName();
      this.checkTotalRecipients();
    } else this.disableSend = true;
  }

  changeValueAndCheckRoleLength() {
    // Validate the role length
    if (this.recipient.role.length > 255) {
      this.disableSend = true;
    }

    this.changeValue()
  }

  changeValueAndCheckHiringOrgLength() {
    if (this.ENT_8918_MULTIPLE_BC){
      if (this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck]))
        this.recipient['place_work'] = this.recipient['hiring_organisation']

      if (!this.selectedChecksMap[this.acicBackgroundCheck])
        delete this.recipient['hiring_organisation']

      // Validate the place_work length
      if (this.recipient?.place_work?.length > 100) {
        this.disableSend = true;
      }
      this.changeValue()
    }
    else{
      // Validate the place_work length
      if (this.recipient.place_work.length > 100) {
        this.disableSend = true;
      }
      // making sure that either email or phone is entered before allowing data
      if (this.recipient.first_name?.trim() && this.recipient.last_name?.trim() && this.recipient.email && this.recipient.mobile_phone) {
        this.checkRequiredFieldsForCheckName();
        this.checkTotalRecipients();
      } else this.disableSend = true;
    }
  }

  changeValueAndCheckReasonLength() {
    // Validate the Reason length
    if (this.recipient.reason.length > 100) {
      this.disableSend = true;
    }
    // making sure that either email or phone is entered before allowing data
    if (this.recipient.first_name?.trim() && this.recipient.last_name?.trim() && this.recipient.email && this.recipient.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
      this.checkTotalRecipients();
    } else this.disableSend = true;
  }

  changeValueAndCheckRoleReasonLength() {
    if (this.selectedChecksMap[this.nccpcBackgroundCheck] || (this.selectedChecksMap[this.nccbankruptcyBackgroundCheck]))
      this.recipient['reason'] = this.recipient['role']

    if (!this.selectedChecksMap[this.acicBackgroundCheck] && !this.selectedChecksMap[this.ukdbsBackgroundCheck])
      delete this.recipient['role']

    // Validate the role & reason length
    if (this.recipient?.reason?.length > 100 || this.recipient?.role?.length > 255) {
      this.disableSend = true;
    }
    this.changeValue()
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }


  addRecipient() {
    this.saved = true;
    if (!this.recipient.mobile_phone) this.recipient.country_code = '';
    let payload = this.recipient;
    if (this.recipient.first_name && this.recipient.last_name && this.recipient.email && this.recipient.mobile_phone) {
      this.checkRequiredFieldsForCheckName();
      this.checkTotalRecipients();
      this.nextClick.emit({data: payload});
      this._bsModalRef.hide();
    }
  }

  checkRequiredFieldsForCheckName(){
    let fieldsToCheck: any;
    if(this.TRUST_752_VERIFICATION){
        fieldsToCheck = [...this.bgCheckShortNames, ...this.flowShortNames]
          .filter(checkName => Object.keys(this.checkNames).includes(checkName))
          .reduce((acc, checkName) => acc.concat(this.checkNames[checkName]), []);
    }
    else{
        if(this.ENT_8918_MULTIPLE_BC){
          fieldsToCheck = this.bgCheckShortNames
            .filter(checkName => Object.keys(this.checkNames).includes(checkName))
            .flatMap(checkName => this.checkNames[checkName])
        }
        else{
          fieldsToCheck = this.checkNames[this.backgroundCheck];
        }
    }

    if (fieldsToCheck && fieldsToCheck.length > 0) {
      for (const fieldName of fieldsToCheck) {
        if (!this.recipient[fieldName] || this.recipient[fieldName]?.trim() === '') {
          this.disableSend = true;
          return;
        }
      }
    }

    if(this.TRUST_752_VERIFICATION){
        if (this.selectedChecksMap[this.empsqBackgroundCheck]){
            const min = Number(this.recipient['verification_emp_min']);
            const max = Number(this.recipient['verification_emp_max']);
            if (min > max) {
                this.disableSend = true;
                return;
            }
      }
        if (this.selectedChecksMap[this.edusqBackgroundCheck]){
            const min = Number(this.recipient['verification_qual_min']);
            const max = Number(this.recipient['verification_qual_max']);
            if (min > max) {
                this.disableSend = true;
                return;
            }
        }
        if (this.selectedChecksMap[this.cvsqBackgroundCheck]){
            const min = Number(this.recipient['verification_cred_min']);
            const max = Number(this.recipient['verification_cred_max']);
            if (min > max) {
                this.disableSend = true;
                return;
            }
        }

    }

    this.disableSend = false;
  }

  getForm() {
    return this.requestForm;
  }

  phoneUpdate(event) {
    this.recipient.country_code = event['country_code'];
    this.recipient.mobile_phone = event['mobile_phone'] === 'null' ? '' : event['mobile_phone'];
    this.formDirty = true;
    this.changeValue();
  }

  checkTotalRecipients() {
    if (this.total >= ConstantsService.REFERENCE_RECIPIENTS_LIMIT) {
      this.disableSend = true;
      this.errorMessage = {
        'type': 'danger',
        'message': this.errorTotalRefs
      };
    }
  }

  dropDownOptionSelected(sector) {
    this.formDirty = true;
    this.recipient['employment_sector'] = sector.value;
    this.changeValue();
  }

  employmentCoverageSelected(sector) {
    this.formDirty = true;
    this.recipient['verification_years'] = sector.value;
    this.changeValue();
  }

  employmentQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_emp_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_emp_max'] = sector.value;
    }
    this.changeValue();
  }

  educationQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_qual_min'] = sector.value;
        this.recipient['verification_cred_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_qual_max'] = sector.value;
        this.recipient['verification_cred_max'] = sector.value;
    }
    this.changeValue();
  }

  credentialQuantitySelected(sector, type) {
    this.formDirty = true;
    if(type=='min'){
        this.recipient['verification_cred_min'] = sector.value;
    }
    else if(type=='max'){
        this.recipient['verification_cred_max'] = sector.value;
    }
    this.changeValue();
  }

  employmentTypeOptionSelected(sector) {
    this.formDirty = true;
    this.recipient['type'] = sector.key;
    this.changeValue();
  }

  updateYear(year) {
    this.recipient['birth_year'] = year.value;
  }

  updatefuzziness(fuziness) {
    this.recipient['fuzziness'] = fuziness.key;
    this.fuzziness = fuziness.value;
  }

  isBackgroundCheckSelected(checks) {
      if (this.TRUST_752_VERIFICATION) {
          return checks.some(bgCheck => this.bgCheckShortNames.includes(bgCheck)) || checks.some(bgCheck => this.flowShortNames.includes(bgCheck))
      }
      else {
          return checks.some(bgCheck => this.bgCheckShortNames.includes(bgCheck))
      }
  }

  selectedItemsEmitter($event){
    this.selectedItems = $event;
    this.recipient['country_codes'] = $event.map(item => item.value);

  }

  changeValueAndCheckForRoleLength() {
    if (this.recipient.internal_reference.length > 255) {
      this.disableSend = true;
    } else {
      this.changeValue()
    }
   }
}

